import Dialog from "@material-ui/core/esm/Dialog";
import DialogActions from "@material-ui/core/esm/DialogActions";
import DialogContent from "@material-ui/core/esm/DialogContent";
import DialogTitle from "@material-ui/core/esm/DialogTitle";
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { PrimaryButton, SecondaryButton } from 'components/Button';
import Divider from 'components/Divider/Divider';
import { Title } from 'components/Text';
import { BLACK } from 'constants/colors';
import useStyles from './DialogStyles';
export default function DialogComponent({
  open,
  isLoading,
  onClose,
  dialogTitle,
  primaryBtnTitle,
  onPrimaryBtnClick,
  primaryBtnClickIsDisabled,
  children,
  optionalActionButton,
  optionalsubmitButton,
  optionalClass
}) {
  const {
    dialogTitleStyle,
    closeIcon,
    submitButton,
    actionButtons,
    submitButtonOptional
  } = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    "aria-labelledby": "dialog-component",
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "dialog-component"
  }, /*#__PURE__*/React.createElement("div", {
    className: dialogTitleStyle
  }, /*#__PURE__*/React.createElement(Title, {
    component: "h1"
  }, dialogTitle), /*#__PURE__*/React.createElement(SecondaryButton, {
    className: closeIcon,
    outlined: false,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    htmlColor: BLACK
  })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent, null, children), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement("div", {
    className: optionalClass
  }, /*#__PURE__*/React.createElement("div", {
    className: optionalsubmitButton ? submitButtonOptional : submitButton
  }, /*#__PURE__*/React.createElement(PrimaryButton, {
    onClick: onPrimaryBtnClick,
    loading: isLoading,
    disabled: primaryBtnClickIsDisabled
  }, primaryBtnTitle)), optionalActionButton && /*#__PURE__*/React.createElement("div", {
    className: actionButtons
  }, optionalActionButton))));
}